var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6248",
    "data-name": "Rectangle 6248",
    width: 16,
    height: 16,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19414",
    "data-name": "Group 19414",
    transform: "translate(0.042 0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19413",
    "data-name": "Group 19413",
    transform: "translate(-0.042 -0.042)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20330",
    "data-name": "Path 20330",
    d: "M7.958,0a7.958,7.958,0,1,0,7.958,7.958A7.966,7.966,0,0,0,7.958,0m3.284,8.578H8.578v2.664a.618.618,0,0,1-.62.62.629.629,0,0,1-.62-.62V8.578H4.675a.629.629,0,0,1-.62-.62.618.618,0,0,1,.62-.62H7.338V4.675a.62.62,0,0,1,1.24,0V7.338h2.664a.618.618,0,0,1,.62.62A.641.641,0,0,1,11.242,8.578Z",
    transform: "translate(0.047 0.047)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.e3bf97955b3c9f295c281c55cae6e941.svg";
export { ForwardRef as ReactComponent };